import React from 'react';

import './QuestionLabel.less';

const labelValue = 'label';
const legendValue = 'legend';

type labelType = typeof labelValue;
type legendType = typeof legendValue;

export interface QuestionLabelProps {
  as: labelType | legendType,
  // The input id the label should be associated with
  labelInputId: string | number,
  html: string,
  number: number,
  totalQuestions: number,
}

export function QuestionLabel({
  as = 'label',
  labelInputId = '',
  html,
  number,
  totalQuestions,
}: QuestionLabelProps): JSX.Element {
  if (as === legendValue) {
    return (
      <legend className="question_label">
        {/* eslint-disable-next-line react/no-danger */}
        <span dangerouslySetInnerHTML={{ __html: html }} />
        <span className="progress_count">{` (${number} of ${totalQuestions})`}</span>
      </legend>
    );
  }
  return (
    <label className="question_label" htmlFor={labelInputId.toString()}>
      {/* eslint-disable-next-line react/no-danger */}
      <span dangerouslySetInnerHTML={{ __html: html }} />
      <span className="progress_count">{` (${number} of ${totalQuestions})`}</span>
    </label>
  );
}

export default QuestionLabel;
